import { googleLogin, login } from "@/api/auth.api";
import apiClient from "@/axios";

const FIVE_MINUTES = 5 * 60 * 1000;

const state = {
  token: localStorage.getItem("token") || null,
  isAuthenticated: false,
  user: null,
  lastCheckedAt: 0,
};

const mutations = {
  SET_TOKEN(state, { token, user }) {
    state.token = token;
    state.user = user;
    localStorage.setItem("token", token);
  },
  logout(state) {
    state.token = null;
    state.user = null;
    localStorage.removeItem("token");
  },
  setAuth(state, { isAuthenticated, timestamp }) {
    state.isAuthenticated   = isAuthenticated;
    state.lastCheckedAt     = timestamp;
  },
  setToken(state, token) {
    state.token = token;
  }
};

const actions = {
  async login({ commit }, { email, password }) {
    try {
      const response = await login(email, password);
      if (response.data.status) {
        commit("SET_TOKEN", {
          token: response.data.data.apiToken,
          user: response.data.data,
        });
        return { success: true };
      } else {
        return { success: false, message: response.data.msg };
      }
    } catch (error) {
      return {
        success: false,
        message: "Login failed. Please try again later.",
      };
    }
  },
  async loginGoogle({ commit }, { cerdidential }) {
    try {
      const response = await googleLogin(cerdidential);
      if (response.data.status) {
        commit("SET_TOKEN", {
          token: response.data.data.apiToken,
          user: response.data.data,
        });
        return { success: true };
      } else {
        return { success: false, message: response.data.msg };
      }
    } catch (error) {
      return {
        success: false,
        message: "Login failed. Please try again later.",
      };
    }
  },
  async logout({ commit }) {
    try {
      await apiClient.post("/user/logout", {
        token: token,
      });
    } catch (error) {
      //console.error("Logout error:", error);
    } finally {
      commit("logout");
    }
  },  
  async loginSocial({ commit }, { provider }) {
    try {
      const response = await apiClient.post("/auth/"+ provider +"/redirect",);
      if (response.data.status) {
        commit("SET_TOKEN", {
          token: response.data.data.apiToken,
          user: response.data.data,
        });
        return { success: true };
      } else {
        return { success: false, message: response.data.msg };
      }
    } catch (error) {
      return {
        success: false,
        message: "Login failed. Please try again later.",
      };
    }
  },
  async checkToken({ state, commit }) {
      const token = state.token; 
      if (!token) {
        return false; 
      }
    const now = Date.now();
    if (state.lastCheckedAt && (now - state.lastCheckedAt) < FIVE_MINUTES) {
      return state.isAuthenticated;
    }

    try {

      const response = await apiClient.post('/check-token', { token });
      const valid  = response.data.status;
      commit('setAuth', { isAuthenticated: valid, timestamp: now });
      return valid;
      return response.data.status; 
    } catch (error) {
      commit('setAuth', { isAuthenticated: false, timestamp: now });
      return false;
      return false; 
    }
  },
};

const getters = {
  token: (state) => state.token,
  isAuthenticated: (state) => state.isAuthenticated,
  currentUser: (state) => state.user,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};